import React from "react";
import CartSidebar from "./components/CartSidebar";
import BillingForm from "./components/BillingForm";
import {createRoot} from "react-dom/client";

export default () => {
    const cartSidebar = document.querySelector('[data-cart-sidebar]');
    if (cartSidebar) {
        const sidebarRoot = createRoot(cartSidebar);
        sidebarRoot.render(
            <CartSidebar
                edit={parseInt(cartSidebar.getAttribute('data-edit')) === 1}
                event={cartSidebar.getAttribute('data-event')}
                submit={cartSidebar.getAttribute('data-submit')}
                base_url={cartSidebar.getAttribute('data-base-url')} />
        );
    }

    const billingForm = document.querySelector('[data-billing-app]');
    if (billingForm) {
        const billingRoot = createRoot(billingForm);
        billingRoot.render(
            <BillingForm
                base_url={billingForm.getAttribute('data-base-url')} />
        );
    }
}
